import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AngularMaterialModule } from '../../angular-material-module/angular-material.module';
import { MatSliderModule } from '@angular/material/slider';
import { PersonalRoutingModule } from './personal-routing.module';
import { PersonalComponent } from './personal.component';
import { PersonalDetailComponent } from './personalDetail/personal-detail.component';
import { DatosPersonalesComponent } from './datos-personales/datos-personales.component';
import { DatosOrganizativosComponent } from './datos-organizativos/datos-organizativos.component';
import { DireccionesComponent } from './direcciones/direcciones-cab/direcciones.component';
import { FamiliaresComponent } from './familiares/familiares-cab/familiares.component';
import { ContratosComponent } from './contratos/contratos.component';
import { DatosBancoComponent } from './datos-banco/datos-banco.component';
import { SueldoComponent } from './sueldos/sueldo-cab/sueldo.component';
import { HorariosTrabajoComponent } from './horarios-trabajo/horarios-trabajo.component';
import { CuentaCorrienteComponent } from './cuenta-corriente/cuenta-corriente.component';
import { IboxtoolsModule } from '../../components/common/iboxtools/iboxtools.module';
import { ComboToolsModule } from '../../components/common/comboTools/comboTools.module';

import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AltaPersonalComponent } from './alta-personal/alta-personal.component';
import {ToastModule} from 'primeng/toast';
import {PanelModule} from 'primeng/panel';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { TranslateModule } from '@ngx-translate/core';

import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';

import {MatStepperModule} from '@angular/material/stepper';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from '../../components/shared/shared.module';
import { DireccionDetalleComponent } from './direcciones/direccion-detalle/direccion-detalle.component';
import { DireccionesListComponent } from './direcciones/direcciones-list/direcciones-list.component';
import { FamiliaresListComponent } from './familiares/familiares-list/familiares-list.component';
import { FamiliarDetalleComponent } from './familiares/familiar-detalle/familiar-detalle.component';
import { InfoIdentidadListComponent } from './infoIdentidad/info-identidad-list/info-identidad-list.component';
import { ConfigToolsModule } from '../../components/common/configTools/configTools.module';
import { DatosFechasListComponent } from './datosFechas/datos-fechas-list/datos-fechas-list.component';
import { AfiliacionesListComponent } from './afiliaciones/afiliaciones-list/afiliaciones-list.component';
import { SueldoEditarDialogComponent } from './sueldos/sueldo-editar-dialog/sueldo-editar-dialog.component';
import { NumeroDecimalPipe } from '../../utils/numero-decimal.pipe';
import { NovedadesPeriodoListComponent } from './novedadesPeriodo/novedades-periodo-list/novedades-periodo-list.component';
import { NovedadesTiemposListComponent } from './novedadesTiempos/novedades-tiempos-list/novedades-tiempos-list.component';
import { NovedadesMesListComponent } from './novedadesMes/novedades-mes-list/novedades-mes-list.component';
import { NovedadesPeriodoComponent } from './novedadesPeriodo/novedades-periodo/novedades-periodo.component';
import { NovedadesPeriodoDetalleComponent } from './novedadesPeriodo/novedades-periodo-detalle/novedades-periodo-detalle.component';
import { NovedadesMesComponent } from './novedadesMes/novedades-mes/novedades-mes.component';
import { NovedadesMesDetalleComponent } from './novedadesMes/novedades-mes-detalle/novedades-mes-detalle.component';
import { DatosEstadoNominaComponent } from './datos-estadoNomina/datos-estado-nomina.component';
import { NominasEspecialesDetalleComponent } from './nominasEspeciales/nominas-especiales-detalle/nominas-especiales-detalle.component';
import { NominasEspecialesComponent } from './nominasEspeciales/nominas-especiales/nominas-especiales.component';
import { NominasEspecialesListComponent } from './nominasEspeciales/nominas-especiales-list/nominas-especiales-list.component';
import { AusentismosListComponent } from './ausentismos/ausentismos-list/ausentismos-list.component';
import { ContingentesListComponent } from './contingentes/contingentes-list/contingentes-list.component';
import { ReporteConstanciaFiltComponent } from './reportesPersonal/reporteConstancia/reporte-constancia-filt.component';
import { NovedadesTiemposComponent } from './novedadesTiempos/novedades-tiempos/novedades-tiempos.component';
import { NovedadesTiemposDetalleComponent } from './novedadesTiempos/novedades-tiempos-detalle/novedades-tiempos-detalle.component';
import { AfiliacionesCabComponent } from './afiliaciones/afiliaciones-cab/afiliaciones-cab.component';
import { AfiliacionesDetalleComponent } from './afiliaciones/afiliaciones-detalle/afiliaciones-detalle.component';
import { InfoIdentidadCabComponent } from './infoIdentidad/info-identidad-cab/info-identidad-cab.component';
import { InfoIdentidadDetalleComponent } from './infoIdentidad/info-identidad-detalle/info-identidad-detalle.component';
import { DatosFechasCabComponent } from './datosFechas/datos-fechas-cab/datos-fechas-cab.component';
import { DatosFechasDetalleComponent } from './datosFechas/datos-fechas-detalle/datos-fechas-detalle.component';
import { ContingentesCabComponent } from './contingentes/contingentes-cab/contingentes-cab.component';
import { ContingentesDetalleComponent } from './contingentes/contingentes-detalle/contingentes-detalle.component';
import { AusentismosCabComponent } from './ausentismos/ausentismos-cab/ausentismos-cab.component';
import { AusentismosDetalleComponent } from './ausentismos/ausentismos-detalle/ausentismos-detalle.component';
import { DatosIIGGComponent } from './datos-iigg/datos-iigg.component';
import { DeducionesIiggComponent } from './deduccionesIIGG/deduciones-iigg/deduciones-iigg.component';
import { DeducionesIiggListComponent } from './deduccionesIIGG/deduciones-iigg-list/deduciones-iigg-list.component';
import { DeducionesIiggDetalleComponent } from './deduccionesIIGG/deduciones-iigg-detalle/deduciones-iigg-detalle.component';
import { OtroEmpleadorComponent } from './otroEmpleador/otro-empleador/otro-empleador.component';
import { OtroEmpleadorEditarDialogComponent } from './otroEmpleador/otro-empleador-editar-dialog/otro-empleador-editar-dialog.component';
import { SeguridadSocialComponent } from './seguridad-social/seguridad-social.component';
import { PersonalListComponent } from './personalList/personal-list.component';
import { IndemnizacionComponent } from './indemnizaciones/indemnizacion/indemnizacion.component';
import { IndemnizacionEditarDialogComponent } from './indemnizaciones/indemnizacion-editar-dialog/indemnizacion-editar-dialog.component';
import { ImportacionDatosComponent } from './importacion-datos/importacion-datos.component';
import { FichaMedicaListComponent } from './fichaMedica/ficha-medica-list/ficha-medica-list.component';
import { FichaMedicaEditarDialogComponent } from './fichaMedica/ficha-medica-editar-dialog/ficha-medica-editar-dialog.component';
import { FichaMedicaAvancesListComponent } from './fichaMedica-avances/ficha-medica-avances-list/ficha-medica-avances-list.component';
import { FichaMedicaAvancesEditarDialogComponent } from './fichaMedica-avances/ficha-medica-avances-editar-dialog/ficha-medica-avances-editar-dialog.component';

@NgModule({
  declarations: [PersonalComponent, 
                PersonalDetailComponent, 
                DatosPersonalesComponent, 
                DatosOrganizativosComponent, 
                DireccionesComponent, 
                FamiliaresComponent, 
                ContratosComponent, 
                DatosBancoComponent, 
                SueldoComponent, 
                HorariosTrabajoComponent, 
                CuentaCorrienteComponent,
    AltaPersonalComponent,
    DireccionDetalleComponent,
    DireccionesListComponent,
    FamiliaresListComponent,
    FamiliarDetalleComponent,
    InfoIdentidadListComponent,
    DatosFechasListComponent,
    AfiliacionesListComponent,
    SueldoEditarDialogComponent,
    NumeroDecimalPipe,
    NovedadesPeriodoListComponent,
    NovedadesTiemposListComponent,
    NovedadesMesListComponent,
    NovedadesPeriodoComponent,
    NovedadesPeriodoDetalleComponent,
    NovedadesMesComponent,
    NovedadesMesDetalleComponent,
    DatosEstadoNominaComponent,
    NominasEspecialesDetalleComponent,
    NominasEspecialesComponent,
    NominasEspecialesListComponent,
    AusentismosListComponent,
    ContingentesListComponent,
    ReporteConstanciaFiltComponent,
    NovedadesTiemposComponent,
    NovedadesTiemposDetalleComponent,
    AfiliacionesCabComponent,
    AfiliacionesDetalleComponent,
    InfoIdentidadCabComponent,
    InfoIdentidadDetalleComponent,
    DatosFechasCabComponent,
    DatosFechasDetalleComponent,
    ContingentesCabComponent,
    ContingentesDetalleComponent,
    AusentismosCabComponent,
    AusentismosDetalleComponent,
    DatosIIGGComponent,
    DeducionesIiggComponent,
    DeducionesIiggListComponent,
    DeducionesIiggDetalleComponent,
    OtroEmpleadorComponent,
    OtroEmpleadorEditarDialogComponent,
    SeguridadSocialComponent,
    PersonalListComponent,
    IndemnizacionComponent,
    IndemnizacionEditarDialogComponent,
    ImportacionDatosComponent,
    FichaMedicaListComponent,
    FichaMedicaEditarDialogComponent,
    FichaMedicaAvancesListComponent,
    FichaMedicaAvancesEditarDialogComponent],
  imports: [
    CommonModule,
    PersonalRoutingModule,
    IboxtoolsModule,
    ComboToolsModule,
    FormsModule, ReactiveFormsModule,
    AngularMaterialModule,
    MatSliderModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    ToastModule,
    PanelModule,
    MatStepperModule,
    CalendarModule,
    CheckboxModule,
    RadioButtonModule,
    TranslateModule,
    DropdownModule,
    TableModule,
    ToastModule,
    ButtonModule,
    SharedModule,
    ConfigToolsModule,
    PdfViewerModule,
    MatSlideToggleModule
  ],
  exports: [TranslateModule],
  providers: [NumeroDecimalPipe],
})

export class PersonalModule { }
